function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { commonTemplateType, responsiveTemplateType } from './PropTypes/common-proptypes';
import useConvertProps from './utilities/hooks/useConvertProps';
import styles from '@dtsl/css-grid/dist/index.module.css';
const Grid = props => {
  const {
    children,
    as = 'div',
    ...restProps
  } = props;
  const {
    gridStyles,
    reactProps
  } = useConvertProps(restProps);
  const {
    style,
    className,
    ...otherReactProps
  } = reactProps;
  const gridClasses = classNames({
    [styles['naos-grid']]: true,
    [className]: !!className
  });
  const GridTag = as || 'div';
  return /*#__PURE__*/React.createElement(GridTag, _extends({
    style: {
      ...gridStyles,
      ...style
    },
    className: gridClasses
  }, otherReactProps), children);
};
Grid.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  as: PropTypes.string,
  columns: commonTemplateType,
  rows: commonTemplateType,
  areas: PropTypes.oneOfType([PropTypes.array, responsiveTemplateType]),
  children: PropTypes.node,
  gutter: commonTemplateType,
  colGutter: commonTemplateType,
  rowGutter: commonTemplateType,
  margin: commonTemplateType
};
export default Grid;